// extracted by mini-css-extract-plugin
export default {"editorWidth":"29.7cm","tableWidth":"26.7cm","btn-container":"styles_btn-container__HUnXf","btn-label":"styles_btn-label__9Ctrn"};